import colors from "../../../../../../common/styles/colors";
import { BadgeStatuses } from "../../../../../../common/enums";
import { makeStyles } from "@mui/styles";
import { ComponentWithChildren } from "../../../../../../common/types";

const defaultStyles = {
  ["@media (max-width: 992px)"]: {
    background: "transparent",
    marginTop: "8px !important",
    marginBottom: "8px !important"
  }
};

const useStyles = makeStyles({
  pending: {
    background: `${colors.yellow["100"]} !important`,
    ...defaultStyles
  },
  cancelled: {
    background: colors.red["50"],
    ...defaultStyles
  },
  rejected: {
    background: colors.red["50"],
    ...defaultStyles
  },
  contentContainer: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    "& > div, & > span": {
      fontWeight: "normal !important"
    }
  },
  container: {
    height: "100%",
    padding: "0px 8px",
    ...defaultStyles
  }
});

type Props = {
  status?: BadgeStatuses;
};

export const StatusTableRow: ComponentWithChildren<Props> = ({ children, status }) => {
  const classes = useStyles();
  const styles = status ? classes[status.toLowerCase()] : "";

  return (
    <div className={`${classes.container} ${styles}`}>
      <div className={classes.contentContainer}>{children}</div>
    </div>
  );
};
